<template>
  <div :class="$style.tab">
    <button @click="$emit('click')">{{ text }}</button>
  </div>
</template>

<script>
export default {
  props: {
    text: { type: Number, default: null },
  },
}
</script>

<style lang="less" module>
@tab-width: 0.86rem;
@tab-height: 1.25rem;
@tab-btn-size: 0.59rem;
@tab-font-size: 0.18rem;
@tab-cup-width: 0.48rem;
@tab-cup-height: 0.5rem;

.tab-size(@r: 1) {
  .tab {
    .size(@tab-width * @r, @tab-height * @r);

    button {
      .size(@tab-btn-size * @r);
      font-size: @tab-font-size * @r;
    }

    &:global(.selected) {
      &::before {
        .size(@tab-cup-width * @r, @tab-cup-height * @r);
      }
    }
  }
}

.tab-size();

@media screen and (max-width: @tablet-width) {
  .tab-size(1.2);
}

@media screen and (max-width: @mini-width) {
  .tab-size(2);
}

@media screen and (max-width: @mobile-width) {
  .tab-size(2.2);
}

// 激活状态
.active() {
  background-color: @primary;
  color: #fff;
  box-shadow: 0 0 0.1rem 0.05rem fade(#ff3d4c, 23%);
}

.tab {
  position: relative;
  margin: 0 auto;

  button {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin: 0 auto;
    border-radius: 100%;
    background-color: #e2c692;
    font-weight: 700;
    transform: translateY(-50%);
    transition: background-color 0.3s, box-shadow 0.3s;

    &:hover {
      .active();
    }
  }

  &:global(.selected) {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      background: url('./images/honor-cup.png') no-repeat;
      background-size: 100% 100%;

      :global {
        animation: fadeInUp 0.3s both;
      }
    }

    button {
      .active();
    }
  }
}
</style>
